import React, { Component } from 'react'

/**
 * Styles
 */
import './RegistrationForm.css'

/**
 * Modules
 */
import { Modal, Select, Input, message, Button, Form, Switch, Spin } from 'antd';
import { getPaymentCheckPhotoUrl, addCompetitor, addPaymentCheckPhoto, updateCompetitor } from '../../../utils/competitorsFunctions';

import { getAuth, onAuthStateChanged } from 'firebase/auth';

class RegistrationForm extends Component {

    constructor(props) {
        super(props)

        this.state = {
            isUserLoggedIn: false,
            studentAddObjectNome: '',
            studentAddObjectSexo: '',
            studentAddObjectFaixa: '',
            studentAddObjectPeso: '',
            studentAddObjectPesoQtd: '',
            studentAddObjectIdade: '',
            studentAddObjectEquipe: '',
            studentAddObjectPhone: '',
            studentAddObjectFile: undefined,
            studentAddDisabledButton: false,
            loading: false,
            initialValue: [{}, {}, {}, {}, {}, {}, {}],
            confirmedPayment: false,

            loadingUpdate: false,
            hasFile: false,
            loadingFile: true,
        }
    }

    componentDidMount = () => {
        this.getFormData();
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.competitorToUpdate && (JSON.stringify(this.props.competitorToUpdate) !== JSON.stringify(prevProps.competitorToUpdate)))
            this.getFormData();
    }

    getFormData = async () => {
        this.setState({ loadingFile: true })

        // Check if user is conected
        const auth = getAuth();
        onAuthStateChanged(auth, user => {
            if (user) {
                this.setState({ isUserLoggedIn: true })
            }
        });

        this.setState({
            studentAddObjectNome: '',
            studentAddObjectSexo: '',
            studentAddObjectFaixa: '',
            studentAddObjectPeso: '',
            studentAddObjectPesoQtd: '',
            studentAddObjectIdade: '',
            studentAddObjectEquipe: '',
            studentAddObjectPhone: '',
            studentAddObjectFile: undefined,
            studentAddDisabledButton: false,
            loading: false,
            initialValue: [{}, {}, {}, {}, {}, {}, {}]
        })

        if (this.props.competitorToUpdate) {
            // Check if payment was made
            let url = await getPaymentCheckPhotoUrl(this.props.competitorToUpdate.__key);
            this.setState({
                urlOfComprovante: url,
                hasFile: true,
                loadingFile: false,
                studentAddObjectFile: { name: this.props.competitorToUpdate.checkingCopyName ? this.props.competitorToUpdate.checkingCopyName : 'Arquivo sem nome' }
            });

            this.setState({
                initialValue: [
                    { initialValue: this.props.competitorToUpdate['nome'] },
                    { initialValue: this.props.competitorToUpdate['sexo'] },
                    { initialValue: this.props.competitorToUpdate['faixa'] },
                    { initialValue: this.props.competitorToUpdate['peso'] },
                    { initialValue: this.props.competitorToUpdate['idade'] },
                    { initialValue: this.props.competitorToUpdate['equipe'] },
                    { initialValue: this.props.competitorToUpdate['phone'] },
                ],
                studentAddObjectNome: this.props.competitorToUpdate['nome'],
                studentAddObjectSexo: this.props.competitorToUpdate['sexo'],
                studentAddObjectFaixa: this.props.competitorToUpdate['faixa'],
                studentAddObjectPeso: this.props.competitorToUpdate['peso'],
                studentAddObjectIdade: this.props.competitorToUpdate['idade'],
                studentAddObjectEquipe: this.props.competitorToUpdate['equipe'],
                studentAddObjectPhone: this.props.competitorToUpdate['phone'],
                confirmedPayment: this.props.competitorToUpdate['confirmedPayment'],
            })
        } else {
            this.setState({ loadingFile: false })
        }
    }

    addFieldValue = (field, value) => {
        if (field === 'nome') {
            this.setState({
                studentAddObjectNome: value
            })
        } else if (field === 'peso') {
            this.setState({
                studentAddObjectPesoQtd: value
            })
        } else if (field === 'phone') {
            this.setState({
                studentAddObjectPhone: value
            })
        }
    }

    addFieldValueSexo = (value) => {
        this.setState({
            studentAddObjectSexo: value
        })
    }

    addFieldValueFaixa = (value) => {
        this.setState({
            studentAddObjectFaixa: value
        })
    }

    addFieldValuePeso = (value) => {
        this.setState({
            studentAddObjectPeso: value
        })
    }

    addFieldValueIdade = (value) => {
        this.setState({
            studentAddObjectIdade: value
        })
    }

    addFieldValueEquipe = (value) => {
        this.setState({
            studentAddObjectEquipe: value
        })
    }

    chooseFile = () => {
        document.getElementById('selectCompetitorFile').click()
    }

    getFile = (file) => {
        this.setState({
            studentAddObjectFile: file.target.files[0],
            hasFile: true,
        })
    }

    removeFile = () => {
        this.setState({
            studentAddObjectFile: undefined,
            hasFile: false
        })
    }

    createStudent = async (champ, champId) => {
        /* Disable button until a response from firebase */
        this.setState({ loading: true })

        /* Get the file to put in firebase */
        let localFile = this.state.studentAddObjectFile

        if (
            this.state.studentAddObjectNome !== '' &&
            this.state.studentAddObjectSexo !== '' &&
            this.state.studentAddObjectFaixa !== '' &&
            this.state.studentAddObjectPeso !== '' &&
            this.state.studentAddObjectIdade !== '' &&
            this.state.studentAddObjectEquipe !== '' &&
            localFile !== undefined
        ) {
            /* get weight chart */
            let localQuadroDePesos = this.props.quadroDePesos

            /* Loop para identificar o sexo */
            let finalPeso = -1
            for (let sKey in localQuadroDePesos) {
                if (sKey === this.state.studentAddObjectSexo) {

                    /* Loop para identificar a idade */
                    for (let iKey in localQuadroDePesos[sKey]) {
                        if (iKey === this.state.studentAddObjectIdade) {

                            /* Loop final para identificar o peso */
                            for (let pKey in localQuadroDePesos[sKey][iKey]) {
                                if (pKey === this.state.studentAddObjectPeso) {
                                    finalPeso = localQuadroDePesos[sKey][iKey][pKey]
                                }
                            }
                            break
                        }
                    }
                    break
                }
            }

            let localStudentToPush = {
                nome: this.state.studentAddObjectNome,
                sexo: this.state.studentAddObjectSexo,
                faixa: this.state.studentAddObjectFaixa,
                peso: this.state.studentAddObjectPeso,
                pesoQtd: finalPeso,
                idade: this.state.studentAddObjectIdade,
                equipe: this.state.studentAddObjectEquipe,
                phone: this.state.studentAddObjectPhone,
                apto: true,
                wasDeleted: false,
                momentOfCreation: new Date().getTime(),
                confirmedPayment: false,
                checkingCopyName: localFile.name
            }

            let idOfStudentAddedInChamp = ''

            /* Push competitor in firebase champ */
            let studentAddedInChamp = await addCompetitor(champId, localStudentToPush);
            idOfStudentAddedInChamp = studentAddedInChamp.key;

            /* Push photo in firebase */
            if (localFile !== undefined)
                await addPaymentCheckPhoto(idOfStudentAddedInChamp, localFile);

            /* Put real key in student on champ */
            await updateCompetitor(champId, idOfStudentAddedInChamp, { realKey: idOfStudentAddedInChamp });

            this.setState({
                loading: false,
                studentAddObjectFile: null,
                hasFile: false
            })

            message.success('Inscrição realizada com sucesso')

            /* Clear form */
            this.props.form.resetFields();

            this.props.updateStudentList();
        } else {
            this.setState({ loading: false })
            message.error('Todos os dados são obrigatórios')
        }
    }

    checkPayment = (value) => {
        this.setState({ confirmedPayment: value })
    }

    updateCompetitor = async (champ, key, champId) => {
        this.setState({ loadingUpdate: true });
        if (
            this.state.studentAddObjectNome !== '' &&
            this.state.studentAddObjectSexo !== '' &&
            this.state.studentAddObjectFaixa !== '' &&
            this.state.studentAddObjectPeso !== '' &&
            this.state.studentAddObjectIdade !== '' &&
            this.state.studentAddObjectEquipe !== '' &&
            this.state.studentAddObjectFile !== undefined
        ) {
            /* get weight chart */
            let localQuadroDePesos = this.props.quadroDePesos;

            let finalPeso = -1
            for (let sKey in localQuadroDePesos) {
                if (sKey === this.state.studentAddObjectSexo) {

                    /* Loop para identificar a idade */
                    for (let iKey in localQuadroDePesos[sKey]) {
                        if (iKey === this.state.studentAddObjectIdade) {

                            /* Loop final para identificar o peso */
                            for (let pKey in localQuadroDePesos[sKey][iKey]) {
                                if (pKey === this.state.studentAddObjectPeso) {
                                    finalPeso = localQuadroDePesos[sKey][iKey][pKey]
                                }
                            }
                            break
                        }
                    }
                    break
                }
            }

            let localStudentToUpdate = {
                nome: this.state.studentAddObjectNome,
                sexo: this.state.studentAddObjectSexo,
                faixa: this.state.studentAddObjectFaixa,
                peso: this.state.studentAddObjectPeso,
                pesoQtd: finalPeso,
                idade: this.state.studentAddObjectIdade,
                equipe: this.state.studentAddObjectEquipe,
                phone: this.state.studentAddObjectPhone,
                confirmedPayment: this.state.confirmedPayment,
                checkingCopyName: this.state.studentAddObjectFile.name
            }

            /* Update competitor in firebase champ */
            await updateCompetitor(champId, key, localStudentToUpdate);

            message.success('Atualização realizada com sucesso')
            this.setState({ loadingUpdate: false, hasFile: false })

            /* Clear form */
            this.props.form.resetFields();

            this.props.updateStudentList();
        } else {
            this.setState({ loadingUpdate: false })
            message.error('Todos os dados são obrigatórios')
        }
    }

    deleteCompetitor = async (champ, key, champId) => {
        let _this = this

        Modal.confirm({
            title: 'Tem certeza que deseja excluir esse competidor?',
            content: 'Essa operação não poderá ser desfeita',
            okText: 'Sim',
            okType: 'danger',
            cancelText: 'Não',
            async onOk() {
                /* Delete competitor in firebase champ */
                await updateCompetitor(champId, key, { wasDeleted: true });

                _this.props.closeModal();
                message.success('Exclusão realizada com sucesso');

                this.props.updateStudentList();
            }
        })
    }

    render() {

        const { getFieldDecorator } = this.props.form

        return (
            <div>
                <Form layout='horizontal'>
                    <Form.Item style={{ marginBottom: '10px' }}>
                        {getFieldDecorator('name', this.state.initialValue[0])(
                            <Input
                                placeholder="Nome do aluno"
                                onChange={e => this.addFieldValue('nome', e.target.value)}
                                className='sharedInput browser-default'
                                id='registrationInputNameId'
                            />
                        )}
                    </Form.Item>

                    <Form.Item style={{ width: '49%', marginRight: '2%', marginBottom: '10px', float: 'left' }}>
                        {getFieldDecorator('sexo', this.state.initialValue[1])(
                            <Select
                                showSearch
                                className='sharedInput'
                                placeholder="Sexo"
                                optionFilterProp="children"
                                onChange={this.addFieldValueSexo}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                id='registrationInputSexoId'
                            >
                                <Select.Option value={null}> </Select.Option>
                                <Select.Option value="Masculino">Masculino</Select.Option>
                                <Select.Option value="Feminino">Feminino</Select.Option>
                            </Select>
                        )}
                    </Form.Item>

                    <Form.Item style={{ width: '49%', marginBottom: '10px', float: 'left' }}>
                        {getFieldDecorator('phone', this.state.initialValue[6])(
                            <Input
                                placeholder="Telefone para contato"
                                onChange={e => this.addFieldValue('phone', e.target.value)}
                                className='sharedInput browser-default'
                                id='registrationInputPhoneId'
                            />
                        )}
                    </Form.Item>

                    <Form.Item style={{ width: '49%', marginRight: '2%', marginBottom: '10px', float: 'left' }}>
                        {getFieldDecorator('faixa', this.state.initialValue[2])(
                            <Select
                                showSearch
                                className='sharedInput'
                                placeholder="Faixa do aluno"
                                optionFilterProp="children"
                                onChange={this.addFieldValueFaixa}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                id='registrationInputFaixaId'
                            >
                                <Select.Option value={null}> </Select.Option>
                                <Select.Option value="whiteSmoke">Branca</Select.Option>
                                <Select.Option value="grey">Cinza</Select.Option>
                                <Select.Option value="yellow">Amarela</Select.Option>
                                <Select.Option value="orange">Laranja</Select.Option>
                                <Select.Option value="green">Verde</Select.Option>
                                <Select.Option value="#ffcc99">Colorido</Select.Option>
                                <Select.Option value="blue">Azul</Select.Option>
                                <Select.Option value="purple">Roxa</Select.Option>
                                <Select.Option value="brown">Marrom</Select.Option>
                                <Select.Option value="black">Preta</Select.Option>
                            </Select>
                        )}
                    </Form.Item>

                    <Form.Item style={{ width: '49%', marginBottom: '10px', float: 'left' }}>
                        {getFieldDecorator('peso', this.state.initialValue[3])(
                            <Select
                                showSearch
                                className='sharedInput'
                                placeholder="Peso do aluno"
                                optionFilterProp="children"
                                onChange={this.addFieldValuePeso}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                id='registrationInputPesoId'
                            >
                                <Select.Option value={null}> </Select.Option>
                                <Select.Option value="Galo">Galo</Select.Option>
                                <Select.Option value="Pluma">Pluma</Select.Option>
                                <Select.Option value="Pena">Pena</Select.Option>
                                <Select.Option value="Leve">Leve</Select.Option>
                                <Select.Option value="Médio">Médio</Select.Option>
                                <Select.Option value="Meio Pesado">Meio Pesado</Select.Option>
                                <Select.Option value="Pesado">Pesado</Select.Option>
                                <Select.Option value="Super Pesado">Super Pesado</Select.Option>
                                <Select.Option value="Pesadíssimo">Pesadíssimo</Select.Option>
                            </Select>
                        )}
                    </Form.Item>

                    <Form.Item style={{ width: '49%', marginRight: '2%', marginBottom: '10px', float: 'left' }}>
                        {getFieldDecorator('idade', this.state.initialValue[4])(
                            <Select
                                showSearch
                                className='sharedInput'
                                placeholder="Idade do aluno"
                                optionFilterProp="children"
                                onChange={this.addFieldValueIdade}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                id='registrationInputIdadeId'
                            >
                                <Select.Option value={undefined}> </Select.Option>
                                <Select.Option value="Pré-Mirim">Pré-Mirim</Select.Option>
                                <Select.Option value="Mirim 1">Mirim 1</Select.Option>
                                <Select.Option value="Mirim 2">Mirim 2</Select.Option>
                                <Select.Option value="Infantil 1">Infantil 1</Select.Option>
                                <Select.Option value="Infantil 2">Infantil 2</Select.Option>
                                <Select.Option value="Infanto 1">Infanto 1</Select.Option>
                                <Select.Option value="Infanto 2">Infanto 2</Select.Option>
                                {/*
                                <Select.Option value="Mirim">Mirim</Select.Option>
                                <Select.Option value="Infantil">Infantil</Select.Option>
                                <Select.Option value="Infanto">Infanto</Select.Option>
                                */}
                                <Select.Option value="Juvenil">Juvenil</Select.Option>
                                <Select.Option value="Adulto">Adulto</Select.Option>
                                {/*
                                <Select.Option value="Master">Master</Select.Option>
                                */}
                                <Select.Option value="Master 1">Master 1</Select.Option>
                                <Select.Option value="Master 2">Master 2</Select.Option>
                            </Select>
                        )}
                    </Form.Item>

                    <Form.Item style={{ width: '49%', marginBottom: '10px', float: 'left' }}>
                        {getFieldDecorator('equipe', this.state.initialValue[5])(
                            <Select
                                showSearch
                                className='sharedInput'
                                placeholder="Equipe do aluno"
                                optionFilterProp="children"
                                onChange={this.addFieldValueEquipe}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                id='registrationInputEquipeId'
                            >
                                <Select.Option value={null}> </Select.Option>
                                {
                                    this.props.arrayOfTeams.map(team => {
                                        return (
                                            <Select.Option key={team.nome} value={team.nome}>{team.nome}</Select.Option>
                                        )
                                    })
                                }
                            </Select>
                        )}
                    </Form.Item>


                    {this.state.loadingFile ?
                        <Spin style={{ width: '100%', marginTop: '10px' }} /> :
                        <div>
                            <input id='selectCompetitorFile' type='file' style={{ display: "none" }} onChange={(input) => this.getFile(input)} />
                            {this.state.hasFile ?
                                <div>
                                    <div
                                        className='RegistrationFormFileButton'
                                        onClick={() => window.open(this.state.urlOfComprovante, '_blank').focus()}
                                    >
                                        {this.state.studentAddObjectFile.name}
                                    </div>
                                    <div
                                        className='RegistrationFormFileButton'
                                        onClick={this.removeFile}
                                        style={{ width: '18%', marginLeft: '2%' }}
                                    >
                                        Remover
                                    </div>
                                </div>
                                :
                                <Button
                                    onClick={() => this.chooseFile()}
                                    style={{ width: '100%', float: 'left', marginTop: '4px' }}
                                    htmlType='button'
                                >
                                    Inserir comprovante
                                </Button>
                            }
                        </div>
                    }

                    <div style={{ clear: 'both' }}></div>

                    {this.props.competitorToUpdate ?
                        <div>
                            {
                                this.state.isUserLoggedIn ?
                                    <div style={{ lineHeight: '40px', marginTop: '20px' }}>
                                        <Switch defaultChecked={this.props.competitorToUpdate.confirmedPayment} onChange={this.checkPayment} /> Confirmar pagamento <br />
                                    </div>
                                    : null
                            }

                            <Button
                                type="primary"
                                loading={this.state.loadingUpdate}
                                htmlType='button'
                                onClick={() => this.updateCompetitor(this.props.champInfo, this.props.competitorToUpdate.__key, this.props.champId)}
                                style={{ marginTop: '10px', width: '49%', marginRight: '2%' }}
                            >
                                Atualizar
                            </Button>

                            <Button
                                type="danger"
                                htmlType='button'
                                onClick={() => this.deleteCompetitor(this.props.champInfo, this.props.competitorToUpdate.__key, this.props.champId)}
                                style={{ marginTop: '10px', width: '49%' }}
                            >
                                Deletar
                            </Button>

                            <div style={{ clear: 'both' }}></div>

                        </div>
                        :
                        <div>
                            <Button
                                type="primary"
                                loading={this.state.loading}
                                htmlType='button'
                                onClick={() => this.createStudent(this.props.champInfo, this.props.champId)}
                                style={{ marginTop: '10px', width: '100%' }}
                            >
                                Confirmar
                            </Button>
                        </div>
                    }

                    <div className='RegistrationFormPagseguroButton'>
                        {/* INICIO DO BOTAO PAGSEGURO *
                        <a href="javascript:void(0)" onClick={() => window.PagSeguroLightbox('AA08060D060649199466EF831B86F042')}>
                            <img src="//assets.pagseguro.com.br/ps-integration-assets/botoes/pagamentos/160x20-pagar.gif" alt="Pague com PagSeguro - é rápido, grátis e seguro!" />
                        </a>
                        {/*  FIM DO BOTAO PAGSEGURO */}
                    </div>
                </Form>
            </div>
        )
    }
}

export default Form.create()(RegistrationForm)